import React, { Children } from 'react'

import { Show } from '@app/components/util'

import { isShowComponent } from '@app/typeGuards'

import type { SwitchFC, SwitchProps } from './types'

export const Switch: SwitchFC<SwitchProps> = ({ fallback, children }) => {
  const matchedCase = Children.toArray(children).find(child => isShowComponent(child) && child.props?.condition)

  if (matchedCase !== undefined) {
    return <>{ matchedCase }</>
  }

  return <>{ fallback ?? null }</>
}

Switch.Case = Show
